import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import GetFormaController from './Controller/GetFormaController';
import Footer from './Vue/Components/Footer';
import GetFormaCompController from './Controller/GetFormaCompController';
import GetFormaFAQController from './Controller/GetFormaFAQController';
import GetAllFormationController from './Controller/GetAllFormationController';
import GetAllFormationIncendieController from './Controller/GetAllFormationIncendieController';
import GetAllFormationSecourismeController from './Controller/GetAllFormationSecourismeController';
import GetAllFormationPreventionController from './Controller/GetAllFormationPreventionController';
import LoginController from './Controller/LoginController';
import { Provider } from 'react-redux';
import store from './store/store';
import GetAccueilController from './Controller/GetAccueilController';
import CalendarController from './Controller/CalendarController';
import Quisommesnous from './Vue/Pages/Quisommenous';
import CreateArticleController from './Controller/CreateArticleController';
import 'bootstrap/dist/css/bootstrap.min.css';
import GetAllArticleController from './Controller/GetAllArticleController';
import GetArticleController from './Controller/GetArticleController';
import CreateFormateurController from './Controller/CreateFormateurController';
import ContactView from './Vue/Pages/ContactView';
import ReviewView from './Vue/Pages/ReviewView';
import CGU from './Vue/Pages/CGU';
import CGV from './Vue/Pages/CGV';
import Merci from './Vue/Pages/Merci';

function App() {
  return <>
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/formation/:id" element={<GetFormaController />} />
          <Route path="/compétences/:id" element={<GetFormaCompController />} />
          <Route path="/faq/:id" element={<GetFormaFAQController />} />
          <Route path="/formations" element={<GetAllFormationController />} />
          <Route path="/formations/incendie" element={<GetAllFormationIncendieController />} />
          <Route path="/formations/secourisme" element={<GetAllFormationSecourismeController />} />
          <Route path="/formations/prevention" element={<GetAllFormationPreventionController />} />
          <Route path="/admin" element={<LoginController />} />
          <Route path="/" element={<GetAccueilController />} />
          <Route path="/calendrier" element={<CalendarController />} />
          <Route path="/quisommesnous" element={<Quisommesnous />} />
          <Route path="/createArticle" element={<CreateArticleController />} />
          <Route path="/blog" element={<GetAllArticleController />} />
          <Route path="/blog/:id" element={<GetArticleController />} />
          <Route path="/createFormateur" element={<CreateFormateurController />} />
          <Route path="/contact" element={<ContactView />} />
          <Route path="/avis" element={<ReviewView />} />
          <Route path="/cgu" element={<CGU />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/merci" element={<Merci />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      </Provider>
  </>
}

export default App;
